module.exports = __webpack_public_path__ + "static/img/csmj_qrcode.b1ece67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/mobile/csmj_qrcode.png
// module id = Zhu/
// module chunks = 3